import { combineReducers } from 'redux';
import user from './user';
import lang from './lang';
import categories from "./categories";


export default combineReducers({
    user,
    lang,
    categories
});




// WEBPACK FOOTER //
// ./src/redux/reducers/index.js